// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Model for details about Account Voicemail Opt-In relations
*/
export class VoicemailOptInModel {
    /**
    * @description Party Phone Number identifier
    */
    'phoneNumberId'?: number;
    /**
    * @description Flag indicating if Voicemail is opted in (true) or not (false)
    */
    'isVmOptedIn'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof VoicemailOptInModel>> = [
        {
            "name":     "phoneNumberId",
            "baseName": "phoneNumberId",
            "type":     "number"
        },
        {
            "name":     "isVmOptedIn",
            "baseName": "isVmOptedIn",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return VoicemailOptInModel.attributeTypeMap;
    }
}
